import Marquee from "react-fast-marquee";

const ITEMS = [
  "Bookkeeping",
  "GST Filing",
  "Statutory Audit",
  "ROC Compliance",
  "Tax Planning",
  "Company Setup",
  "Board Minutes",
];

export const EditorialMarquee = () => (
  <div className="bg-[#F8FAFC] border-y border-slate-200 py-8" data-testid="editorial-marquee">
    <Marquee speed={26} gradient={false}>
      {ITEMS.map((item, i) => (
        <span key={i} className="font-serif text-2xl md:text-4xl text-slate-800 mx-10 flex items-center">
          {item}
          <span className="mx-10 text-[#C5A059]">&mdash;</span>
        </span>
      ))}
    </Marquee>
  </div>
);
